import { render, staticRenderFns } from "./moduleForm.vue?vue&type=template&id=07d44444"
import script from "./moduleForm.vue?vue&type=script&lang=js"
export * from "./moduleForm.vue?vue&type=script&lang=js"
import style0 from "./moduleForm.vue?vue&type=style&index=0&id=07d44444&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports